import { TextBox } from './TextBox';

interface BankAccountBoxProps {
    id?: string;
    dataTestid?: string;
    value: string;
    name?: string;
    readOnly?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onValidationEvent?: (isValid: boolean) => void;
}

export const BankAccountBox: React.FC<BankAccountBoxProps> = ({
    id,
    dataTestid,
    value,
    readOnly = false,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    onChange,
    onEnterKey,
    onValidationEvent,
}) => {
    const validateValue = (value: string) => {
        const valid = !(/\D/.test(value)) && value.length === maxLength;
        return valid;
    };

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            value={value}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            onChange={onChange}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            maxLength={maxLength}
            type='tel'
        />
    );
};
